const defaultSidebarWidth: number = 320;

export const minSidebarWidth = 320;

export const maxSidebarWidth = 500;

export default defaultSidebarWidth;
